export default {
  US_CON: 'Continental U.S.',
  US_AK: 'Alaska',
  US_HI: 'Hawaii',
  US_PR: 'Puerto Rico',
  US_OTHER: 'Other U.S. Territories',
};
